import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { camelCaseKeys } from '@utils/case-conversion'

import { StreamStatusDetails } from '@layout-components/general/data-connections/types'

import axiosServices from 'utils/axios'

const fetchStreamStatusDetails = async (
  businessId: number,
  connectedSourceSystemId: number,
  streamStatusId: string | undefined
): Promise<StreamStatusDetails> => {
  const response = await axiosServices.get(
    `/businesses/${businessId}/connected_source_systems/${connectedSourceSystemId}/stream_status_details`,
    { params: { stream_statuses_id: streamStatusId } }
  )
  return camelCaseKeys(response.data)
}

export const useFetchStreamStatusDetails = ({
  businessId,
  connectedSourceSystemId,
  streamStatusId
}: {
  businessId?: number
  connectedSourceSystemId?: number
  streamStatusId?: string | undefined
}) => {
  return useQuery<StreamStatusDetails, Error>({
    queryKey: ['fetch-stream-status-details', streamStatusId],
    queryFn: () => fetchStreamStatusDetails(businessId!, connectedSourceSystemId!, streamStatusId!),
    enabled: !!businessId && !!connectedSourceSystemId && !!streamStatusId
  } as UseQueryOptions<StreamStatusDetails, Error>)
}
